
import { useTranslation } from 'react-i18next';
import Card from '../ui/Card';
import Section from '../ui/Section';
import Container from '../ui/Container';

export default function TechStack() {
  const { t } = useTranslation();

  const technologies = [
    { 
      name: 'AWS', 
      description: t('techStack.aws.description'),
      icon: 'ri-cloud-line',
      color: 'from-orange-400 to-orange-500'
    },
    { 
      name: 'React', 
      description: t('techStack.react.description'),
      icon: 'ri-reactjs-line',
      color: 'from-blue-400 to-blue-500'
    },
    { 
      name: 'JavaScript', 
      description: t('techStack.javascript.description'),
      icon: 'ri-javascript-line',
      color: 'from-yellow-400 to-yellow-500'
    },
    { 
      name: 'TailwindCSS', 
      description: t('techStack.tailwind.description'),
      icon: 'ri-css3-line',
      color: 'from-teal-400 to-teal-500'
    },
    { 
      name: 'Serverless', 
      description: t('techStack.serverless.description'),
      icon: 'ri-function-line',
      color: 'from-purple-400 to-purple-500'
    },
    { 
      name: 'Monolithic', 
      description: t('techStack.monolithic.description'),
      icon: 'ri-building-line',
      color: 'from-green-400 to-green-500'
    }
  ];

  return (
    <Section id="tech-stack" className="py-20 bg-gradient-to-b from-blue-50 to-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-l from-blue-100/50 to-transparent rounded-full transform translate-x-48 -translate-y-48"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-r from-blue-100/50 to-transparent rounded-full transform -translate-x-48 translate-y-48"></div>
      
      <Container className="relative z-10">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4 font-poppins">
            {t('techStack.title')}
          </h2>
          <p className="text-xl text-blue-700 max-w-4xl mx-auto font-inter leading-relaxed">
            {t('techStack.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-3 gap-8 mb-12 max-w-4xl mx-auto">
          {technologies.map((tech, index) => (
            <div key={tech.name} className="text-center group animate-slide-up" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className={`w-20 h-20 bg-gradient-to-r ${tech.color} rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:shadow-xl group-hover:scale-110 group-hover:-rotate-6 transition-all duration-500`}>
                <i className={`${tech.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg font-semibold text-blue-900 mb-2 font-poppins group-hover:text-blue-700 transition-colors duration-300">
                {tech.name}
              </h3>
              <p className="text-sm text-blue-600 font-inter">
                {tech.description}
              </p>
            </div>
          ))}
        </div>

        <Card className="max-w-4xl mx-auto text-center bg-gradient-to-r from-blue-50 to-white border-blue-200 animate-fade-in">
          <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
            <i className="ri-stack-line text-2xl text-white"></i>
          </div>
          <h3 className="text-2xl font-bold text-blue-900 mb-4 font-poppins">
            {t('techStack.architecture.title')}
          </h3>
          <p className="text-blue-700 font-inter leading-relaxed">
            {t('techStack.architecture.description')}
          </p>
        </Card>
      </Container>
    </Section>
  );
}
